export default {
  ERROR: "ERROR",
  ERROR_RESET: "ERROR_RESET",
  GET_AUDIT_REPORT_REQUEST: "GET_AUDIT_REPORT_REQUEST",
  GET_AUDIT_REPORT_RECEIVE: "GET_AUDIT_REPORT_RECEIVE",
  GET_AUDIT_REPORT_ERROR: "GET_AUDIT_REPORT_ERROR"
};
